import { render } from "./ComponentSideBar.vue?vue&type=template&id=f68c48a6&scoped=true"
import script from "./ComponentSideBar.vue?vue&type=script&lang=js"
export * from "./ComponentSideBar.vue?vue&type=script&lang=js"

import "./ComponentSideBar.vue?vue&type=style&index=0&id=f68c48a6&scoped=true&lang=css"

import exportComponent from "/home/cospexa/cospexa.webservice/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f68c48a6"]])

export default __exports__